import { Cog6ToothIcon } from "@heroicons/react/24/outline";
import { Tooltip } from "antd";
import { Button } from "V2.0/common/button";

export default ConfigureStepAction;

function ConfigureStepAction(props) {
  const { onConfigureStep } = props;

  return (
    <Button
      plain
      onClick={(e) => {
        e.stopPropagation();
        onConfigureStep();
      }}
    >
      <Tooltip title="Configure">
        <Cog6ToothIcon className="size-4 text-gray-600" />
      </Tooltip>
    </Button>
  );
}
